import React from 'react';
import axios from 'axios';
import {config} from './../config.js';

class SearchList extends React.Component {
	constructor(props) {
		  super(props);  	 
		  this.state = {
			letter: null,
			id: 0,
			searchQuery: '',
			selectedOption: '',
			definitions: []
		  };
		  this.handleClick = this.handleClick.bind(this);
		  this.handleChange = this.handleChange.bind(this);
		  if ( props && props.match && props.match.params && props.match.params.id ) {
				this.state.id = props.match.params.id;
		  }
		}
	
	
	 handleClick(l) {
		document.getElementById("filter-search").reset();
		this.setState({ letter: l });
		axios.get(config.wsServer+'/apps/ws/styleguide/list/'+l+'/')
	      .then(res => {
	        const definitions = res.data.results;
	        this.setState({ definitions });
	      })
	  }
	 
	 handleChange = event => {
		    this.setState({ letter: event.target.value });
		    document.getElementById("filter-search").reset();
			axios.get(config.wsServer+'/apps/ws/styleguide/list/'+event.target.value+'/')
		      .then(res => {
		        const definitions = res.data.results;
		        this.setState({ definitions });
		      })
		  }
	
	  handleInputChange = event => {
		    this.setState({ letter: 'Search results for "'+event.target.value+'"' });
			axios.get(config.wsServer+'/apps/ws/styleguide/search/?q='+event.target.value+'/')
		      .then(res => {
		        const definitions = res.data.results;
		        this.setState({ definitions });
		      })
		  };
		  
	componentDidMount() {
		if ( this.state.id > 0 ) {
			this.setState({ letter: '' });
			axios.get(config.wsServer+'/apps/ws/styleguide/list/'+this.state.id+'/')
		      .then(res => {
		        const definitions = res.data.results;
		        this.setState({ definitions });
		      })
		}
	}

 	
	render() {
		const letters = Array.from({ length: 26 }, (_, i) => String.fromCharCode('A'.charCodeAt(0) + i));
		const listItems = letters.map((letter) =>
		  <li className="page-item small" key={letter}><button className="page-link" onClick={() => this.handleClick(letter)}>{letter}</button></li>
		);
		const listOptions = letters.map((letter) =>
		  <option key={letter} value={letter}>{letter}</option>
		);
        return (
        	<div className="searchBox">
        	  <div className="bg-light p-2">
        	    <a className="float-right btn btn-sm btn-secondary m-1" href="/apps/styleguide/print/">Print</a>
		        <form id="filter-search" className="form-inline">
		            <input
		              className="form-control mb-2"
		              placeholder="Keyword search"
		              value={this.state.query}
		              onChange={this.handleInputChange}
		            />
		        </form>
	        	<nav aria-label="Browse A to Z" className="table-responsive BrowseSearch">
	      		  <ul className="pagination d-none d-md-flex">
	      		     {listItems}
	      		  </ul>
	      		  <select name="azSearch" className="d-block d-md-none form-control" value={this.state.selectedOption} onChange={this.handleChange}>
		  			<option value="">A to Z Index</option>
				     {listOptions}
				  </select>
	      		</nav>
	      	  </div>
	      	  <div className="p-3">
	      	  	<h4 className="mt-2">{this.state.letter}</h4>
	      	  	{ this.state.definitions.map(definition => <dl className="row border-top pt-3" key={definition.style_id}><dt className="col-sm-3 text-sm-right h-5" dangerouslySetInnerHTML={{__html:definition.label}} /><dd className="col-sm-9" dangerouslySetInnerHTML={{__html:definition.descr}} /></dl>)} 
	          </div>
	      	</div>
        );
  }
}

export default SearchList;

